import { IonAvatar, IonImg, IonSpinner } from "@ionic/react";
import { useState } from "react";
import { useBotsStore } from "../stores/bots.store";

interface BotAvatarProps {
  botId?: string | undefined;
  img?: string;
  small?: boolean;
  progress?: number;
}

const BotAvatar: React.FC<BotAvatarProps> = ({
  botId,
  img,
  small,
  progress = 0
}) => {
  const bot = useBotsStore(state => state.bots.find(b => b.id === botId));
  const [loading, setLoading] = useState(true);
  return (
    <IonAvatar
      className={`${
        small ? "h-[42px] w-[42px]" : "h-32 w-32"
      }  bg-slate-300 relative ${progress > 0 && "mt-5"} border-white border`}
    >
      {progress > 0 && (
        <div className="absolute inset-0">
          {/* <CircularProgressBar percentage={progress} sqSize={128} /> */}
        </div>
      )}
      {loading && (
        <div className="flex items-center justify-center h-full">
          <IonSpinner className="w-10 h-10" />
        </div>
      )}
      <IonImg
        src={img || bot?.img}
        alt="icon-2"
        className={`${small ? "h-[42px] w-[42px]" : "h-32 w-32"}`}
        onIonImgDidLoad={() => setLoading(false)}
        style={{ visibility: loading ? "hidden" : "visible" }}
      />
      {
        <span className="absolute -mt-4">
          <IonImg
            className="w-4 h-4"
            src={`https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/${(
              bot?.quoteAsset || "USDT"
            ).toLowerCase()}.png`}
          />
        </span>
      }
    </IonAvatar>
  );
};

export default BotAvatar;
